import api from '../../../../api/api';
import { toast } from 'react-toastify';

export const fetchChats = (forceRefresh = false) => async dispatch => {
    dispatch({ type: 'WHATSAPP_CHATS_LOADING' });
    try {
        const response = await api.get(`/green/chats${forceRefresh ? '?forceRefresh=true' : ''}`);
        if (response.data && Array.isArray(response.data)) {
            dispatch({ type: 'WHATSAPP_CHATS_SUCCESS', chats: response.data });
        } else {
            dispatch({ type: 'WHATSAPP_CHATS_SUCCESS', chats: [] });
        }
    } catch (error) {
        dispatch({ type: 'WHATSAPP_CHATS_ERROR' });
        // Since we don't have access to the translation object 't' directly here,
        // we can handle error messages on the component or dispatch error.
    }
};

export const fetchHistory = (chatId, showLoading = true) => async dispatch => {
    dispatch({ type: 'WHATSAPP_HISTORY_LOADING', showLoading });
    try {
        const response = await api.get(`/green/history?chatId=${chatId}&count=50`);
        if (response.data && Array.isArray(response.data)) {
            dispatch({ type: 'WHATSAPP_HISTORY_SUCCESS', messages: response.data });
        } else {
            dispatch({ type: 'WHATSAPP_HISTORY_SUCCESS', messages: [] });
        }
    } catch (error) {
        dispatch({ type: 'WHATSAPP_HISTORY_ERROR' });
    }
};

export const selectChat = (chat) => dispatch => {
    dispatch({ type: 'WHATSAPP_SELECT_CHAT', chat });
    dispatch(fetchHistory(chat.id, true));
};

export const sendMessage = (chatId, messageText, t) => async (dispatch, getState) => {
    dispatch({ type: 'WHATSAPP_SEND_MESSAGE_START' });
    try {
        const response = await api.post('/green/message', {
            chatId: chatId,
            message: messageText
        }, {
            headers: { 'Content-Type': 'application/json' }
        });

        if (response.data && response.data.success) {
            const newMsgObj = {
                type: 'outgoing',
                timestamp: Math.floor(Date.now() / 1000),
                textMessage: messageText,
                idMessage: 'temp_' + Date.now()
            };
            dispatch({ type: 'WHATSAPP_SEND_MESSAGE_SUCCESS', message: newMsgObj });
        } else {
            toast.error(t("Pages.WhatsApp.errorOccurred"));
            dispatch({ type: 'WHATSAPP_SEND_MESSAGE_ERROR' });
        }
    } catch (error) {
        toast.error(t("Pages.WhatsApp.errorOccurred"));
        dispatch({ type: 'WHATSAPP_SEND_MESSAGE_ERROR' });
    }
};

export const updateChats = (chats) => dispatch => {
    dispatch({ type: 'WHATSAPP_UPDATE_CHATS', chats });
};
